import React from 'react';
import {
    ComposedChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import './HiringVelocityChart.css';

/**
 * HiringVelocityChart Component
 * Displays hiring velocity trend with bars for hires and line for time-to-hire
 */
function HiringVelocityChart({ data, loading, goalLine }) {
    if (loading) {
        return (
            <div className="chart-container chart-loading">
                <div className="chart-loading-spinner"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="chart-container chart-empty">
                <p>No hiring data available</p>
            </div>
        );
    }

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="chart-tooltip">
                    <p className="chart-tooltip-label">{label}</p>
                    {payload.map((entry, index) => (
                        <p key={index} className="chart-tooltip-item" style={{ color: entry.color }}>
                            {entry.name}: {entry.value}
                            {entry.dataKey === 'avgTimeToHire' ? ' days' : ''}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className="chart-container">
            <div className="chart-header">
                <h3 className="chart-title">Hiring Velocity Trend</h3>
                <div className="chart-legend-custom">
                    <span className="legend-item">
                        <span className="legend-bar" style={{ background: '#E67E22' }}></span>
                        Hires
                    </span>
                    <span className="legend-item">
                        <span className="legend-line" style={{ background: '#95A5A6' }}></span>
                        Avg Time-to-Hire
                    </span>
                </div>
            </div>
            <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="monthLabel"
                        tick={{ fontSize: 12, fill: '#7F8C8D' }}
                        axisLine={{ stroke: '#e5e7eb' }}
                    />
                    <YAxis
                        yAxisId="left"
                        orientation="left"
                        tick={{ fontSize: 12, fill: '#7F8C8D' }}
                        axisLine={{ stroke: '#e5e7eb' }}
                        label={{ value: 'Hires', angle: -90, position: 'insideLeft', fill: '#7F8C8D', fontSize: 12 }}
                    />
                    <YAxis
                        yAxisId="right"
                        orientation="right"
                        tick={{ fontSize: 12, fill: '#7F8C8D' }}
                        axisLine={{ stroke: '#e5e7eb' }}
                        label={{ value: 'Days', angle: 90, position: 'insideRight', fill: '#7F8C8D', fontSize: 12 }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar
                        yAxisId="left"
                        dataKey="hires"
                        name="Hires"
                        fill="#E67E22"
                        radius={[4, 4, 0, 0]}
                        barSize={40}
                    />
                    <Line
                        yAxisId="right"
                        type="monotone"
                        dataKey="avgTimeToHire"
                        name="Avg Time-to-Hire"
                        stroke="#95A5A6"
                        strokeWidth={2}
                        dot={{ fill: '#95A5A6', strokeWidth: 2, r: 4 }}
                        activeDot={{ r: 6 }}
                    />
                    {goalLine && (
                        <Line
                            yAxisId="left"
                            type="monotone"
                            dataKey={() => goalLine}
                            stroke="#27AE60"
                            strokeDasharray="5 5"
                            strokeWidth={2}
                            dot={false}
                            name="Goal"
                        />
                    )}
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
}

export default HiringVelocityChart;
